<template>
  <div class="container mt-5">
    <h2 class="text-center">Forgot Password?</h2>
    <form @submit.prevent="callForgotPassword" class="mt-4">
      <!-- Email Field -->
      <div class="mb-3">
        <label for="email" class="form-label">email</label>

        <input
          type="email"
          class="form-control"
          id="email"
          label="email"
          v-model="localEmail"
          required
        />
      </div>

      <!-- Error Message -->
      <div v-if="error" class="alert alert-danger">
        {{ error }}
      </div>
      <div v-if="resetSent" class="">
        <p>Password reset link sent.</p>
        <p>Check your Junk email if you don't see it in your inbox.</p>
      </div>
      <!-- Buttons -->
      <button
        v-if="!resetSent"
        type="submit"
        class="btn btn-primary w-100"
        :disabled="isLoading"
      >
        <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status"></span>
        <span v-else>Send Password Reset Request</span>
      </button>
      <button
        type="button"
        class="btn btn-link w-100 mt-2"
        @click="$emit('show-home')"
      >
        Back to Home
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: "ForgotPassword",
  props: {
    email: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      localEmail: "", // User's email (local copy that can be edited)
      isLoading: false, // Loading state for the login button
      error: null, // Error message on login failure
      resetSent: false, 
    };
  },
  created() {
    // Initialize localEmail with the prop value
    this.localEmail = this.email;
  },
  methods: {
    async callForgotPassword() {
      this.isLoading = true;
      this.error = null;
      

      try {
        // API Call
        const response = await fetch(`${this.$API_BASE_URL}/api/auth/forgot-password/${this.localEmail}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          }
        });

        if (response.ok) {
          const responseData = await response.text();
          this.resetSent = true;          
        } else {
          // Handle errors from the API
          const errorData = await response.json();
          this.error = errorData.message || "Failed to sign in. Please try again.";
        }
      } catch (err) {
        // Handle network or unexpected errors
        this.error = "An error occurred. Please check your connection.";
        console.error(err);
      } finally {
        this.isLoading = false; // Reset loading state
      }
    },
    
  },
};
</script>

<style scoped>
/* Add any component-specific styles if needed */
.alert {
  margin-top: 1rem;
}
.spinner-border {
  vertical-align: middle;
}
</style>
